export const HIDDEN_METAFIELD = {
  key: 'hidden',
  value: 'true'
};
